import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAWSAuth as useAuth } from '../contexts/AWSAuthContext';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { Loader } from 'lucide-react';

const LoadingContainer = styled.div`
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, ${theme.colors.background.secondary} 0%, ${theme.colors.background.primary} 100%);
`;

const LoadingSpinner = styled(Loader)`
  animation: spin 1s linear infinite;
  color: ${theme.colors.primary[500]};
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingSpinner size={48} />
      </LoadingContainer>
    );
  }

  if (!user) {
    // Redirect to sign in page with return url
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
